// src/services/api.js
import axios from 'axios';
import { toast } from 'react-toastify';
import { extractErrorMessages } from '../utils/formErrorUtils';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,// senin backend URL'in
});

// Token'ı request'lere ekle (yapı korunmuştur)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // headers yoksa güvenli ekleme
      if (!config.headers) config.headers = {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Expired token kontrolü → logout (yapı korunmuştur) + global toastlar
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    // Ağ / zaman aşımı
    if (error?.code === 'ECONNABORTED' || error?.message === 'Network Error') {
      toast.error('Ağ hatası. Lütfen bağlantınızı kontrol edin.');
    }
    else if (status === 422) {
      const validationMessages = extractErrorMessages(error);
      if (validationMessages.length > 0) {
        validationMessages.forEach((msg) => toast.error(msg));
      } else {
        toast.error('Form doğrulama hatası. Lütfen bilgileri kontrol edin.');
      }
    }
    // Sunucu hataları
    else if (status >= 500) {
      toast.error('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
    }
    // 404
    else if (status === 404) {
      toast.error('İstenen kaynak bulunamadı.');
    }
    // 403
    else if (status === 403) {
      toast.error('Bu işlemi yapmaya yetkiniz yok.');
    }
    // 400 vb. genel hata mesajı
    else if (status && status !== 401) {
      const serverMessage =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        'Bir hata oluştu.';
      toast.error(serverMessage);
    }

    // 401: Mevcut logout davranışın AYNEN korundu
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || '';
      const skipGlobal401Handler = Boolean(error.config?.skipGlobal401Handler);
      const isAuthRequest =
        typeof requestUrl === 'string' &&
        (
          requestUrl.includes('/auth/login') ||
          requestUrl.includes('/auth/') ||
          requestUrl.includes('/login')
        );

      if (!skipGlobal401Handler && !isAuthRequest) {
        toast.error('Oturumunuzun süresi dolmuş olabilir. Lütfen tekrar giriş yapın.');
        console.warn('Token geçersiz veya süresi dolmuş. Otomatik çıkış yapılıyor.');
        localStorage.removeItem('token');
        window.location.href = '/login'; // refresh ile login sayfasına yönlendir
      }
    }

    return Promise.reject(error);
  }
);

export default api;
